<template>
  <div class="k-ingredient-card" @click="$emit('click')">
    <img v-if="cover_url" v-deferred-image="cover_url" loading="lazy" decoding="async" alt="">
    <div v-else style="min-width: 100px;"></div>
    <div class="d-flex justify-content-between w-100">
      <div class="k-ingredient-card__header">
        <p class="k-ingredient-card__header-main">
          {{ title }}
        </p>
        <p v-if="description" class="k-ingredient-card__header-additional">
          {{ description }}
        </p>
      </div>
    </div>
    <div class="d-flex">
      <div class="k-ingredient-card__select"
           :class="{ active: isActive }"
      >
        <svg width="16" height="12" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1.5 3.52308L3.21429 5L6.5 1" stroke="white" stroke-width="1.5" stroke-linecap="round"
                stroke-linejoin="round"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { deferredImage } from "../utils/deferred-image";
export default {
  directives: { deferredImage },
  name: "IngredientCard",
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
    },
    cover_url: {
      type: String,
      required: false,
    },
    isActive: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.k-ingredient-card {
  cursor: pointer;
  user-select: none;

  width: 380px;
  min-height: 80px;
  margin-left: 12px;
  margin-right: 12px;
  margin-bottom: 4px;
  background: #FFFFFF;
  border: 1px solid #EEEEF0;
  box-sizing: border-box;
  display: flex;
  box-shadow: 1px 2px 20px rgba(0, 0, 0, 0.05);
  align-items: center;
  word-break: break-word;

  padding: 12px 18px;

  img {
    max-width: 100px;
    clip-path: circle();
    -webkit-clip-path: circle();
  }
}

.k-ingredient-card__select {
  border: 1px solid #F7981E;
  box-sizing: border-box;
  min-width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 4px;
  margin-left: 4px;

  svg {
    display: none;
  }

  &.active {
    background: #F7981E;

    svg {
      display: block;
    }
  }
}

.k-ingredient-card__header {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  pointer-events: none;

  p {
    margin: 0;
  }
}

.k-ingredient-card__header-main {
  font-size: 17px;
  color: #616161;
  line-height: 1;
}

.k-ingredient-card__header-additional {
  font-weight: 600;
  font-size: 12px;
  color: #000000;
}

@media (max-width: 767.98px) {
  .k-ingredient-card img {
    max-width: 70px;
    max-height: 100%;
  }
  .k-ingredient-card {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
  }
  .k-ingredient-card__select {
    min-width: 32px;
    height: 32px;
    margin-right: 15px;

    svg {
      width: 17px;
      height: 13px;
    }
  }

  .search-box {
    margin-top: 10px;
    margin-left: 10px;
    margin-right: 10px;
    width: calc(100% - 20px);
  }
}
</style>
